module.exports = __webpack_public_path__ + "assets/img/OverGet_btn.d5aa4df4.png";